'use strict';

import _ from 'lodash';

import './LoginPage.less';

import { LOGIN_WITH_TOKEN_ERROR } from 'ck-core/source/data/LoginWithTokenError';

const CKImage = require('ck-core-client/source/ui/image');
const MessageBar = require('../ui/MessageBar');
const Button = require('ck-core-client/source/ui/Button');
const LegacyForm = require('ck-core-client/source/ui/LegacyForm');
const Frame = require('ck-core-client/source/ui/Frame');
const LoginController = require('ck-core-client/source/controllers/LoginController');
const Page = require('ck-core-client/source/ui/Page');
const AuthProviders = require('../ui/AuthProviders');
const products = require('ck-core/source/data/products');

module.exports = Page.define({
	type: 'LoginPage',

	title: require('ck-core-client/source/functions/generatePageTitle')(
		require('./LoginPageLang').TITLE
	),
	fullWidth: true,

	init_controller: function() {
		this.controller = new LoginController(this);
		this.actions(Frame, this.controller);
	},

	init_change: function(parent, redirect, urlArgs) {
		if (urlArgs.logout) {
			const UserManager = require('ck-core-client/source/managers/UserManager');
			UserManager.mod().logout();
		}

		this.change('user', async cursor => {
			var loggedIn = cursor.$exists();

			if (_.isArray(redirect)) {
				redirect = redirect[0];
			}

			if (loggedIn) {
				this.processRedirect(redirect, urlArgs);
			}
		});
	},

	init_ui: function(parent, urlPath, urlArgs) {
		let redirect = urlPath[0];

		this.urlArgs = urlArgs;

		this.heading = $('<div class="title">').text(require('./LoginPageLang').HEADER);

		this.greyBox = $('<div class="wrapper">');

		const elements = [
			{
				name: 'username',
				elementValue: urlArgs.name
			},
			{
				name: 'password',
				elementType: 'password'
			}
		];

		if (AuthProviders.shouldUse()) {
			elements.unshift(
				new AuthProviders({
					handleAuthRequest: async (authProvider, reset) => {
						this.form.submitButton.setPending(true);

						try {
							await LoginController.authenticate(null, null, {
								authProvider
							});
						} catch (err) {
							// LoginController.authenticate handles its own errors but also completes before the user is redirected
							// Keep the button disabled unless there is an error
							this.form.submitButton.setPending(false);
							reset();
						}
					}
				}).dom
			);
		}

		this.form = new LegacyForm({
			bootstrap: LegacyForm.BOOTSTRAP_47,
			elements,
			lang: require('./LoginPageLang').FORM,
			submit: 'login',

			submitButton: new Button(require('./LoginPageLang').LOGIN_BUTTON, 'login')
		});

		const StaffModeManager = require('ck-core-client/source/managers/StaffModeManager');

		const staffModeManager = StaffModeManager.mod();

		if (staffModeManager && staffModeManager.getSession()) {
			this.form.buttonWrapper.append(
				new Button(require('./LoginPageLang').STAFF_LOGIN_BUTTON, 'login:true').dom
			);
		}

		this.form.buttonWrapper.append(
			new Button(require('./LoginPageLang').SEND_EMAIL_LOGIN_LINK, 'sendEmailLoginLink').dom
		);

		this.forgotPassword = $('<a>')
			.text(require('./LoginPageLang').FORGOT_PASSWORD)
			.attr('href', '#forgot');

		this.form.addElement($('<div class="forgotPassword">').append(this.forgotPassword));
		var warningText;

		switch (redirect) {
			case 'roblox':
			case 'sequencer':
				warningText = require('./LoginPageLang').WARNING.SEQUENCER;
				break;
			case 'checkout':
				warningText = require('./LoginPageLang').WARNING.CHECKOUT;
				break;

			case 'discount':
				warningText = require('./LoginPageLang').WARNING.DISCOUNT;
				break;

			case 'invalid':
				warningText = LOGIN_WITH_TOKEN_ERROR.INVALID;
				break;
			case 'expired':
				warningText = LOGIN_WITH_TOKEN_ERROR.EXPIRED;
				break;
			case 'alreadyUsed':
				warningText = LOGIN_WITH_TOKEN_ERROR.ALREADY_USED;
				break;
		}

		this.mustLogin = new MessageBar('warning', warningText).hide();

		if (warningText) {
			this.mustLogin.show();
		}

		const notRegistered = new MessageBar(
			'info',
			`${require('./LoginPageLang').NOT_REGISTERED} <a href="/">${
				require('./LoginPageLang').START_HERE
			}</a>`
		);

		this.append(
			CKImage('login-bottom-left').addClass('bottomLeft'),
			CKImage('login-top-right').addClass('topRight'),
			CKImage('generic-white-cloud').addClass('cloud1'),
			CKImage('generic-white-cloud').addClass('cloud2'),
			CKImage('generic-white-cloud').addClass('cloud3'),
			this.heading,
			this.mustLogin,
			this.greyBox.append(this.form.dom).append(notRegistered.dom.addClass('notRegistered'))
		);
	},

	processRedirect: function(redirect, urlArgs) {
		if (redirect === 'sequencer') {
			document.location.href = CK.config.environment.clients.minecraftSequencer.address;
			return;
		}
		if (redirect === 'roblox') {
			document.location.href = CK.config.environment.clients.robloxSequencer.address;
			return;
		} else if (redirect === 'redeemGift') {
			this._parent.navigate('/gift/' + CK.fn.createQueryString(urlArgs));
			return;
		}

		if (!this._parent) {
			return;
		}

		if (redirect === 'discount' || (_.isArray(redirect) && redirect[0] === 'discount')) {
			this._parent.navigate('/apply-discount/' + CK.fn.createQueryString(this.urlArgs));
		} else if (redirect === 'account' || (_.isArray(redirect) && redirect[0] === 'account')) {
			this._parent.navigate('/account/' + CK.fn.createQueryString(this.urlArgs));
		} else if (CK.user.isCampUser() || CK.config.name.startsWith('ck-camps')) {
			let campUrl = (CK.user
				.roles()
				.camps()
				.url() || [])[0];

			if (!campUrl || CK.config.name.startsWith('ck-camps')) {
				this._parent.navigate('/');
			} else {
				document.location.href = '//' + campUrl + CK.config.environment.campDomainBase;
			}
		} else if (CK.user.subUsers().$size()) {
			this._parent.navigate('/account/');
		} else if (CK.user.canUseMinecraft()) {
			this._parent.navigate('/platform-select/');
		} else if (CK.user.hasHadAPlan()) {
			this._parent.navigate('/account/');
		} else {
			this._parent.navigate('/start-modding/');
		}
	},

	checkForFinishedCamp: async function() {
		const denyStatus = CK.user.getMinecraftDenyStatus();
		if (denyStatus) {
			if (CK.user.isCampStudent()) {
				const gainedStudentAccess = await CK.clientSockets.users.emit('gainStudentAccess', {
					product: products.MINECRAFT
				});

				if (!gainedStudentAccess) {
					// Check for having left a group and camp allows readonly access
					if (
						denyStatus ===
							require('ck-core/source/data/editorDenyStatus').CAMP_NO_LICENCED_GROUPS &&
						CK.user.canUseMinecraft() &&
						CK.user.projects().$size() >= 1
					) {
						return true;
					}
				}
			}
		}
	}
});
